function r(r) {
  return r && "object" == typeof r && "default" in r ? r.default : r;
}
var s = r(require("jsonp")),
  e = r(require("query-string")),
  i = {
    props: {
      url: { required: !0, type: String },
      userId: { required: !0, type: String },
      listId: { required: !0, type: String },
    },
    data: function () {
      return {
        fname: null,
        lname: null,
        language: null,
        email: null,
        success: !1,
        error: null,
        loading: !1,
      };
    },
    computed: {
      data: function () {
        const language = this.$store.getters.lang;

        return e.stringify({
          u: this.userId,
          id: this.listId,
          EMAIL: this.email,
          LNAME: this.lname,
          FNAME: this.fname,
          MMERGE6: language, // عربى
        });
      },
    },
    methods: {
      setEmail: function (r) {
        void 0 === r && (r = ""), (this.email = r.trim());
      },
      setField: function (fieldname, fieldvalue) {
        if (fieldname == "name") {
          this.fname = fieldvalue.split(" ")[1];
          this.lname = fieldvalue.split(" ")[0];
        }
      },
      subscribe: function () {
        null === this.email ||
          this.loading ||
          ((this.success = !1),
          (this.error = null),
          (this.loading = !0),
          s(this.url + "?" + this.data, { param: "c" }, this.onResponse));
      },
      onResponse: function (r, s) {
        (this.loading = !1),
          r && (this.error = r),
          s &&
            "error" === s.result &&
            (this.error = this.formatErrorMessage(s.msg)),
          this.error
            ? this.$emit("error", this.error)
            : ((this.success = !0), (this.email = null), this.$emit("success"));
      },
      formatErrorMessage: function (r) {
        return r.replace("0 - ", "");
      },
    },
    render: function () {
      return this.$scopedSlots.default({
        subscribe: this.subscribe,
        setEmail: this.setEmail,
        setField: this.setField,
        error: this.error,
        success: this.success,
        loading: this.loading,
      });
    },
  };
module.exports = i;
//# sourceMappingURL=vue-mailchimp-subscribe.js.map
